module.exports = __webpack_public_path__ + "img/subtitle.81b59d4d.png";